<table>
  <thead>
    <tr>
      <th>Name</th>
    </tr>
  </thead>
  <tbody>
    @for (user of users; track user) {
      <tr>
        <td>{{user.name}}</td>
        <td>-</td>
      </tr>
    }
  </tbody>
</table>
